jQuery(document).ready(function($) {
  
  $('body').on('click', '.custom-filter-btn', function(event) {
    $(this).toggleClass('open');
    $('#sidebar_primary').toggleClass('open');
  });
  
  
  $('.product-slider-2').slick({
    autoplay: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: false,
    dots: false,
    asNavFor: '.slider-nav-thumbnails',

  });
 
  $('.slider-nav-thumbnails').slick({
    autoplay: false,
    slidesToShow: 3, 
    slidesToScroll: 1,
    asNavFor: '.product-slider-2',
    arrows: false,
    focusOnSelect: true
  });
});



$(document).ready(function(){
     $('.custom_banner_slider').owlCarousel({
            loop: true,
            margin: 0,
            nav: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 1
                },
                1000: {
                    items: 1
                }
            }
     });
});
  
